import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#222",
      d: "M5 22q-.825 0-1.413-.588A1.92 1.92 0 0 1 3 20V6q0-.825.588-1.413A1.92 1.92 0 0 1 5 4h1V3q0-.425.288-.713A.96.96 0 0 1 7 2q.425 0 .713.288.288.289.287.712v1h8V3q0-.425.288-.713A.96.96 0 0 1 17 2q.425 0 .713.288.288.289.287.712v1h1q.825 0 1.413.588T21 6v14q0 .825-.588 1.413A1.92 1.92 0 0 1 19 22zm0-2h14V10H5zM5 8h14V6H5z"
    }, null, -1)
  ]))]))
}
export default { render: render }